<template>
  <section>
      <div id="modalCongestionDegree" class="c-modal">
        <div class="c-modal__dialog c-modal__dialog--center">
          <!-- Modal content -->
          <div class="c-modal__content">
            <!-- l-situation -->
            <div class="l-situation">
              <!-- l-situation__head -->
              <div class="l-situation__head mb-8">
                <div class="l-situation__title">混雑状況</div>
                <div class="l-situation__time">
                  <small>{{counterBlocks.date}}</small> <span>{{counterBlocks.time}}</span> 現在
                </div>
              </div>
              <!-- l-situation__note -->
              <div class="l-situation__note mb-12">
                ※5〜15分に一度更新されます。
              </div>
              <!-- c-box-situation -->
              <div class="c-box-situation mb-10" v-if="!counterBlocks || counterBlocks.length == 0">
                混雑状況情報を提供していません。
              </div>
              <div class="c-box-situation mb-10" v-for="(counterBlock, index) in counterBlocks" :key="index">
                <div class="c-box-situation__head">
                  <span class="box-center">{{ counterBlock.blockName }}</span>
                  <span class="social-notice" v-show="counterBlock.isSocialDistance">キープディスタンス混雑度</span>
                </div>
                <div class="c-box-situation__body">
                  <div class="c-situation-chart">
                    <div class="c-percent-circle c-percent-circle--xl" v-bind:class=" { 'c-percent-circle--yellow': counterBlock.currentDensity > 50 } ">
                      <svg
                        viewBox="0 0 36 36"
                        class="c-percent-circle__circular"
                      >
                        <path
                          class="c-percent-circle__circular--bg"
                          d="M18 2.0845
                              a 15.9155 15.9155 0 0 1 0 31.831
                              a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        <path
                          class="c-percent-circle__circular--circle"
                          :stroke-dasharray="counterBlock.density + ', 100'"
                          v-bind:style="{stroke: counterBlock.color}"
                          d="M18 2.0845
                              a 15.9155 15.9155 0 0 1 0 31.831
                              a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        <text x="7" y="16" class="c-percent-circle__name">
                          混雑状況
                        </text>
                        <text
                          x="18"
                          y="24.35"
                          class="c-percent-circle__percentage"
                          v-bind:style="{fill: counterBlock.color}"
                        >
                          {{ counterBlock.density }}%
                        </text>
                      </svg>
                    </div>
                    <div v-if="counterBlock.currentDensity > 50" class="c-situation-chart__text">
                      <img src="/assets/images/text-situation-2.svg" alt="" />
                    </div>
                    <div v-else class="c-situation-chart__text" v-bind:style="{color: counterBlock.color}">
                      {{counterBlock.text && counterBlock.text.text}}
                    </div>
                  </div>
                </div>
              </div>

              <!-- l-situation__foot -->
              <div class="l-situation__foot">
                <a href="javascript:void(0)" class="c-btn-control-modal" id="congestion-cegree-detail" v-show="counterBlocks && counterBlocks.length > 0">
                  <div class="icon-question">?</div>
                  算出方法<br />
                  について
                </a>
                <a href="javascript:void(0)" class="c-btn-close" id="close-modal-congestion-degree">
                  <img src="/assets/images/icon/icon-close-black.svg" alt="" />閉じる
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="modalCongestionDegreeDetail" class="c-modal">
        <div class="c-modal__dialog c-modal__dialog--center">
          <!-- Modal content -->
          <div class="c-modal__content">
            <!-- l-situation -->
            <div class="l-situation">
              <!-- l-situation__head -->
              <div class="l-situation__head mb-8">
                <div class="l-situation__title">混雑状況</div>
                <div class="l-situation__time">
                <small>{{counterBlocks.date}}</small> <span>{{counterBlocks.time}}</span> 現在
                </div>
              </div>
              <!-- l-situation__note -->
              <div class="l-situation__note mb-12">
                ※5〜15分に一度更新されます。
              </div>
              <!-- c-box-situation -->
              <div class="c-box-situation mb-16">
                <div class="c-box-situation__head">
                  <span class="box-center">算出方法</span>
                </div>
                <div class="c-box-situation__body">
                  <div class="c-box-situation__method">
                    <p>キープディスタンスに基づいた最適収容人数に対し、実際に店舗内にいる人数の割合を表示しています。</p>
                  </div>
                </div>
                <div class="c-box-situation__body">
                  <div class="c-box-situation__method">
                    <div class="c-box-situation-conntent mb-30" v-for="(counterBlock, index) in counterBlocks" :key="index">
                      <h1>◎{{ counterBlock.blockName }}</h1>
                      <p>
                        {{ counterBlock.description }}
                      </p>
                  </div>
                  </div>
                </div>
              </div>
              <!-- l-situation__foot -->
              <div class="l-situation__foot">
                <a
                  href="javascript:void(0)"
                  class="c-btn-control-modal c-btn-control-modal--back"
                  id="back-modal-congestion-degree"
                >
                  混雑状況を見る
                </a>
                <a href="javascript:void(0)" class="c-btn-close" id="close-modal-congestion-degree-detail">
                  <img src="/assets/images/icon/icon-close-black.svg" alt="" />閉じる
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
export default Vue.extend({
  name: 'modal_congestion_situation',
  components: {
  },
  props: ['counterBlocks']
})
</script>